import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MyHttpClient } from '../../http-client';
import * as i0 from "@angular/core";
import * as i1 from "../../http-client";
var MakerCheckerService = /** @class */ (function () {
    function MakerCheckerService(http) {
        this.http = http;
    }
    MakerCheckerService.prototype.list = function (status, pageNumber, pageLimit, base) {
        var params = new URLSearchParams();
        if (status) {
            params.set('status', status);
        }
        if (pageNumber != null) {
            params.set('pageNumber', String(pageNumber));
        }
        if (pageLimit != null) {
            params.set('pageLimit', String(pageLimit));
        }
        var query = params.toString() ? "?" + params.toString() : '';
        return this.http.get("" + this.approvalsRoot(base) + query)
            .pipe(catchError(this.handleError));
    };
    MakerCheckerService.prototype.approve = function (id, remark, base) {
        return this.http.post(this.approvalsRoot(base) + "/" + id + "/approve", { remark: remark })
            .pipe(catchError(this.handleError));
    };
    MakerCheckerService.prototype.reject = function (id, remark, base) {
        return this.http.post(this.approvalsRoot(base) + "/" + id + "/reject", { remark: remark })
            .pipe(catchError(this.handleError));
    };
    MakerCheckerService.prototype.approvalsRoot = function (base) {
        return base || environment.server + "/api/limit-store/approvals";
    };
    MakerCheckerService.prototype.handleError = function (error) {
        return throwError(error);
    };
    MakerCheckerService.ngInjectableDef = i0.defineInjectable({ factory: function MakerCheckerService_Factory() { return new MakerCheckerService(i0.inject(i1.MyHttpClient)); }, token: MakerCheckerService, providedIn: "root" });
    return MakerCheckerService;
}());
export { MakerCheckerService };
